import styled from 'styled-components/macro'
import { COLORS } from '../../assets/styles/colors'

export const Paragraph = styled.p`
  color: ${COLORS.NEUTRAL_700};
  font-family: OpenSansRegular, sans-serif, arial;
  font-size: 1.0625rem;
  line-height: inherit;
  margin: 0 0 1.25rem 0;
`

export const Span = styled.span`
  color: ${COLORS.NEUTRAL_700};
`
